import "../../styles/vars.scss";
import "../../styles/compo.scss";
import NavButtonz from "../atoms/NavButtonz";
import "../../styles/atoms.scss";

function TopSns() {

  return (
    <div className="sns-box">
      <NavButtonz
        icon="instagram_line"
        hover="instagram_line"
        className="sns-icon"
        to="https://www.instagram.com/uud.io/"
        target="_blank"
        rel="noopener noreferrer"
        // label="UUD on Instagram"
      />
      <NavButtonz
        icon="twitter_line"
        hover="twitter_line"
        className="sns-icon"
        to="https://x.com/uud_io"
        target="_blank"
        rel="noopener noreferrer"
        // label="UUD on X"
      />
      {/* <NavButtonz icon="dribbble_line" hover="dribbble_line" className="sns-icon" /> */}
      <NavButtonz
        icon="figma_line"
        hover="figma_line"
        className="sns-icon"
        to="https://www.figma.com/@hafido"
        target="_blank"
        rel="noopener noreferrer"
        // label="UUD on Figma"
      />
    </div>
  );
}

export default TopSns;



